export default {
  home: '/',
  nps: '/nps',
  csat: '/csat',
  success: '/success',
  alreadyRating: '/already-rating',
  error: '/error'
} as const

